module.exports = __webpack_public_path__ + "img/cr-wild-capture.bf3aace2.jpg";